export default "__VITE_ASSET__JfF5Mn9___"